import { Suspense, useEffect, useState, useRef } from 'react'
import { Navigate, useRoutes, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { initAuth, selectIsInitialising, selectIsAuthenticated, selectUser, homeRouteForRole } from '../redux/slices/authSlice'
import { lazy } from 'react'
import BlankLayout from '../@core/layouts/BlankLayout'
import AuthenticationRoutes from './routes/AuthenticationRoutes'
import FrtmRoutes           from './routes/FrtmRoutes'
import PageLoader           from '../components/PageLoader'

const NotAuthorized = lazy(() => import('../views/pages/Status/NotAuthorized'))
const Error404      = lazy(() => import('../views/pages/Status/Error'))

const FadeWrapper = ({ children }) => {
  const location    = useLocation()
  const [show, setShow] = useState(false)
  const prevKey     = useRef(null)

  useEffect(() => {
    if (prevKey.current !== location.pathname) {
      setShow(false)
      const t = setTimeout(() => setShow(true), 20)
      prevKey.current = location.pathname
      return () => clearTimeout(t)
    }
    setShow(true)
  }, [location.pathname])

  return (
    <div style={{
      opacity:    show ? 1 : 0,
      transition: 'opacity 0.18s ease',
      minHeight:  '100%',
    }}>
      {children}
    </div>
  )
}

const Router = () => {
  const dispatch        = useDispatch()
  const isInitialising  = useSelector(selectIsInitialising)
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const user            = useSelector(selectUser)

  useEffect(() => { dispatch(initAuth()) }, []) // eslint-disable-line

  const homeRoute = isAuthenticated && user ? homeRouteForRole(user.role) : '/login'

  const tree = useRoutes([
    { path: '/', index: true, element: <Navigate replace to={homeRoute} /> },
    { path: '/auth/not-auth', element: <BlankLayout><Suspense fallback={<PageLoader />}><NotAuthorized /></Suspense></BlankLayout> },
    { path: '*',              element: <BlankLayout><Suspense fallback={<PageLoader />}><Error404 /></Suspense></BlankLayout> },
    ...AuthenticationRoutes,
    ...FrtmRoutes,
  ])

  if (isInitialising) return <PageLoader message="Initialising FRTM…" />

  return (
    <Suspense fallback={<PageLoader />}>
      <FadeWrapper>{tree}</FadeWrapper>
    </Suspense>
  )
}

export default Router